class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    
    // Écouter les événements de rafraîchissement du panier
    this.addEventListener('cart:refresh', this.refreshCart.bind(this));

    // Observer uniquement les changements de la classe is-empty
    this.observer = new MutationObserver((mutations) => {
      const classChange = mutations.find(mutation =>
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class' &&
        (
          mutation.oldValue?.includes('is-empty') !== this.classList.contains('is-empty')
        )
      );

      if (classChange) {
        this.loadImages();
      }
    });

    this.observer.observe(this, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });
  }

  loadImages() {
    const images = this.querySelectorAll('img[lazy-src], img[lazy-srcset]');
    images.forEach(img => {
      if (img.getAttribute('lazy-srcset')) {
        img.setAttribute('srcset', img.getAttribute('lazy-srcset'));
        img.removeAttribute('lazy-srcset');
      }
      if (img.getAttribute('lazy-src')) {
        img.setAttribute('src', img.getAttribute('lazy-src'));
        img.removeAttribute('lazy-src');
      }
    });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
    });

    this.loadImages();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
	    section: this.dataset.sectionId,
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
	    section: 'cart-icon-bubble',
	    selector: '.shopify-section',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  refreshCart() {
    // Rafraîchir le contenu du cart-drawer
    fetch(`${window.Shopify.routes.root}cart?section_id=cart-drawer`)
      .then(response => response.text())
      .then(html => {
        // Mettre à jour le contenu du cart-drawer
        const cartItems = this.querySelector('cart-drawer-items');
        if (cartItems) {
          cartItems.innerHTML = html;
        }
        
        // Mettre à jour aussi l'icône du panier si elle existe
        const cartIcon = document.querySelector('#cart-icon-bubble');
        if (cartIcon) {
          fetch(`${window.Shopify.routes.root}cart?section_id=cart-icon-bubble`)
            .then(response => response.text())
            .then(iconHtml => {
              cartIcon.innerHTML = iconHtml;
            })
            .catch(error => {
              console.error('Erreur lors de la mise à jour de l\'icône du panier:', error);
            });
        }
      })
      .catch(error => {
        console.error('Erreur lors du rafraîchissement du panier:', error);
      });
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: this.dataset.sectionId,
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);
